import React from "react";
import Button from "components/Button";

import { mq } from "utils";
import { sizes } from "assets/constants";

interface AddButtonFloatProps {
  onPress: () => void;
}

export default function AddButtonFloat(props: AddButtonFloatProps) {
  return (
    <Button
      onPress={props.onPress}
      square={mq(50)}
      absolute
      left={sizes.space}
      bottom={sizes.space}
      icon={{ name: "plus", size: 24 }}
    />
  );
}
